<template>
    <div class="form" :class="{'dark-bg-form': !!darkMode, 'form-error': !!natalFormError}">
        <div class="gradient-border">
            <div class="left"></div>
            <div class="right"></div>
            <fieldset class="first">
                <date-picker
                        v-model="inputDate"
                        format="DD.MM.YYYY"
                        lang="ru"
                        v-mask="'##.##.####'"
                        placeholder="дд.мм.гггг"
                        value-type="format"
                        :input-attr="{ id: datePickerId, required: 'true' }"
                        :clearable="false"
                        :first-day-of-week="1">
                    <template slot="calendar-icon">&nbsp;</template>
                </date-picker>
            </fieldset>
            <fieldset class="second">
                <date-picker
                        v-model="inputTime"
                        type="time"
                        format="HH:mm"
                        lang="ru"
                        v-mask="'##:##'"
                        placeholder="чч:мм"
                        value-type="format"
                        :minute-step="1"
                        :input-attr="{ id: timePickerId, required: 'true' }"
                        :clearable="false">
                    <template slot="calendar-icon">&nbsp;</template>
                </date-picker>
            </fieldset>
            <fieldset class="last">
                <city-picker v-model="inputCity"
                             :forward-value="true"
                             :label="cityPickerLabel"/>
            </fieldset>
        </div>
        <span class="error-text"
              v-show="!!natalFormError">Заполните все поля</span>
    </div>
</template>

<script>
    import constants from '@/constants';
    import nativeDom from '@/native-dom.js';
    import {mask} from 'vue-the-mask';
    import moment from 'moment';
    import DatePicker from 'vue2-datepicker';
    import CityPicker from '@/components/CityPicker';

    export default {
        name: 'NatalInput',

        directives: {mask},

        props: ['mode', 'darkMode'],

        components: {
            DatePicker, CityPicker
        },

        data() {
            return {}
        },

        computed: {
            inputDate: {
                get() {
                    let inputDate;
                    switch (this.mode) {
                        case constants.mode.natal:
                            inputDate = this.$store.getters.inputDate;
                            break;
                        default:
                            inputDate = this.$store.getters.transitInputDate;
                    }
                    return inputDate;
                },

                set(val) {
                    switch (this.mode) {
                        case constants.mode.natal:
                            this.$store.commit('setInputDate', val);
                            break;
                        default:
                            this.$store.commit('setTransitInputDate', val);
                    }
                }
            },

            inputTime: {
                get() {
                    let inputTime;
                    switch (this.mode) {
                        case constants.mode.natal:
                            inputTime = this.$store.getters.inputTime;
                            break;
                        default:
                            inputTime = this.$store.getters.transitInputTime;
                    }
                    return inputTime;
                },

                set(val) {
                    switch (this.mode) {
                        case constants.mode.natal:
                            this.$store.commit('setInputTime', val);
                            break;
                        default:
                            this.$store.commit('setTransitInputTime', val);
                    }
                }
            },

            inputCity: {
                get() {
                    let inputCity;
                    switch (this.mode) {
                        case constants.mode.transit:
                        case constants.mode.multimap:
                            inputCity = this.$store.getters.transitInputCity;
                            break;
                        default:
                            inputCity = this.$store.getters.inputCity;
                    }
                    return inputCity;
                },

                set(val) {
                    switch (this.mode) {
                        case constants.mode.transit:
                        case constants.mode.multimap:
                            this.$store.commit('setTransitInputCity', val);
                            break;
                        default:
                            this.$store.commit('setInputCity', val);
                    }
                }
            },

            datePickerId() {
                return `date-picker-${this.mode}`;
            },

            timePickerId() {
                return `time-picker-${this.mode}`;
            },

            datePickerLabel() {
                return this.mode === constants.mode.natal ? 'Дата рождения *' : 'Текущая дата *';
            },

            timePickerLabel() {
                return this.mode === constants.mode.natal ? 'Время рождения *' : 'Текущее время *';
            },

            cityPickerLabel() {
                return this.mode === constants.mode.transit || this.mode === constants.mode.multimap ?
                        'Место нахождения *' : 'Место рождения *';
            },

            currentUserAddress() {
                return this.mode === constants.mode.transit || this.mode === constants.mode.multimap ?
                        this.$store.getters.currentUser.currentAddress :
                        this.$store.getters.currentUser.birthAddress;
            },

            natalFormError() {
                return this.mode === constants.mode.natal
                        && this.$store.getters.natalFormError;
            }
        },

        watch: {
            currentUserAddress(val) {
                this.setCurrentAddress(false);
            }
        },

        created() {
            if (this.mode !== constants.mode.natal) {
                this.inputDate = moment().set({
                    hour: 0,
                    minute: 0,
                    second: 0,
                    millisecond: 0
                }).format("DD.MM.YYYY");
                this.inputTime = moment().format("HH:mm");

                this.setCurrentAddress(true);
            }
        },

        mounted() {
            nativeDom.initLabelForDatePicker({
                id: this.datePickerId,
                label: this.datePickerLabel
            });
            nativeDom.initLabelForTimePicker({
                id: this.timePickerId,
                label: this.timePickerLabel
            });
        },

        methods: {
            setCurrentAddress(checkFromIndexPage) {
                if(!(checkFromIndexPage && this.$store.getters.calculateMapFromIndexPage))
                    switch (this.mode) {
                        case constants.mode.transit:
                        case constants.mode.multimap:
                            // Для Транзита и Мультикарты по умолчанию отображаем место нахождения пользователя из профиля
                            this.inputCity = this.$store.getters.currentUser.currentAddress;
                            break;
                        case constants.mode.direction:
                        case constants.mode.progression:
                            // Для Дирекций и Прогрессий по умолчанию отображаем место рождения пользователя из профиля
                            this.inputCity = this.$store.getters.currentUser.birthAddress;
                            break;
                    }


            }
        }
    }
</script>